import type { MouseEvent, ReactNode } from "react";

import type { OperationsNavigate } from "./navigation";
import { useOperationsPrefetch } from "./operations-prefetch-context";

export function OperationsLink({
  children,
  className,
  href,
  navigate,
  ariaCurrent,
  title,
}: {
  children: ReactNode;
  className?: string;
  href: string;
  navigate: OperationsNavigate;
  ariaCurrent?: "page" | undefined;
  title?: string | undefined;
}) {
  const prefetch = useOperationsPrefetch();
  function click(event: MouseEvent<HTMLAnchorElement>) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      (event.currentTarget.target !== "" && event.currentTarget.target !== "_self") ||
      event.currentTarget.hasAttribute("download")
    ) {
      return;
    }
    const target = new URL(event.currentTarget.href);
    if (target.origin !== window.location.origin) return;
    event.preventDefault();
    navigate(`${target.pathname}${target.search}${target.hash}`);
  }

  return (
    <a
      aria-current={ariaCurrent}
      className={className}
      href={href}
      onClick={click}
      title={title}
      onFocus={() => prefetch?.(href)}
      onPointerEnter={(event) => {
        if (event.pointerType !== "touch") prefetch?.(href);
      }}
    >
      {children}
    </a>
  );
}
